import React, { useState, useEffect } from "react"; // 1. Adicionamos o useEffect
import Navbar from "./components/navbar";
import Footer from "./components/footer";
import Carousel from "./components/carousel";
import ProductGrid from "./components/ProductGrid";
import CartSidebar from "./components/CartSidebar";
import Quemsomos from "./components/quemsomos.js";
import hospitalLogo from "./assets/image/logohospital.png";
import banner from "./assets/image/Banners/banner2.png"; // Verifique se este caminho está correto
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './index.css';

function App() {
  const [cartItems, setCartItems] = useState([]);
  const [cartOpen, setCartOpen] = useState(false);

  // --- Funções do Carrinho ---
  const addToCart = (productToAdd) => {
    setCartItems((prevItems) => {
      const existingItem = prevItems.find((item) => item.title === productToAdd.title);
      if (existingItem) {
        return prevItems.map((item) =>
          item.title === productToAdd.title
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      }
      return [...prevItems, { ...productToAdd, quantity: 1 }];
    });
    setCartOpen(true);
  };

  const handleRemoveFromCart = (productTitle) => {
    setCartItems((prevItems) =>
      prevItems.filter((item) => item.title !== productTitle)
    );
  };

  const handleIncreaseQuantity = (productTitle) => {
    setCartItems((prevItems) =>
      prevItems.map((item) =>
        item.title === productTitle
          ? { ...item, quantity: item.quantity + 1 }
          : item
      )
    );
  };

  const handleDecreaseQuantity = (productTitle) => {
    setCartItems((prevItems) => {
      const existingItem = prevItems.find((item) => item.title === productTitle);
      if (existingItem?.quantity === 1) {
        return prevItems.filter((item) => item.title !== productTitle);
      }
      return prevItems.map((item) =>
        item.title === productTitle
          ? { ...item, quantity: item.quantity - 1 }
          : item
      );
    });
  };

  // --- LÓGICA DO FAVICON ANIMADO ---
  useEffect(() => {
    // 2. CAMINHOS CORRIGIDOS
    // O caminho deve começar com / (relativo à pasta 'public')
    const faviconFrames = [
      '/favicon/frame1.png', // Corrigido
      '/favicon/frame2.png', // Corrigido
      '/favicon/frame3.png', // Corrigido
      '/favicon/frame4.png', // Corrigido
      '/favicon/frame5.png', // Corrigido
      '/favicon/frame6.png', // Corrigido
      '/favicon/frame7.png', // Corrigido
      '/favicon/frame8.png'  // Corrigido
    ];
    let index = 0;

    // Encontra ou cria a tag <link rel="icon">
    let link = document.querySelector('link[rel="icon"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.type = 'image/png'; 

    // 3. Cria o loop de animação
    const intervalId = setInterval(() => {
      link.href = faviconFrames[index];
      index = (index + 1) % faviconFrames.length;
    }, 100); 

    // 4. Limpa o intervalo
    return () => clearInterval(intervalId);
    
  }, []); // O array vazio [] garante que rode apenas uma vez

  // --- Renderização do App ---
  return (
    <>
      <Navbar setCartOpen={setCartOpen} cartItemCount={cartItems.length} />
      
      {/* O id "home" já estava correto */}
      <Carousel id="home" /> 
      
      {/* CORREÇÃO AQUI: removido o '#' do id */}
      <ProductGrid addToCart={addToCart} id="produtos"/> 
      
      <img src={banner} alt="banner" className="h-15 w-full my-5 h-1/2"/>

      {/* Estes já estavam corretos */}
      <Quemsomos id="quemsomos"/>
      <Footer id="contato"/>

      {/* Lógica de renderização do CartSidebar para animação */}
      <CartSidebar 
        cartOpen={cartOpen}
        cartItems={cartItems} 
        onClose={() => setCartOpen(false)}
        onRemove={handleRemoveFromCart}
        onIncrease={handleIncreaseQuantity}
        onDecrease={handleDecreaseQuantity}
      />
    </>
  );
}

export default App;

